import {
  DropdownDownFill18Icon,
  DropdownUpFill18Icon,
} from "@vygruppen/spor-icon-react";
import { Dispatch, SetStateAction } from "react";
import { DropsButton, Flex } from "shared/components/Spor";

interface ExpanderButtonProps {
  showAllStretches: boolean;
  setShowAllStretches: Dispatch<SetStateAction<boolean>>;
  stretchCount: number;
}

export const ExpanderButton = ({
  showAllStretches,
  setShowAllStretches,
  stretchCount,
}: ExpanderButtonProps) => {
  if (stretchCount <= 3) return null;

  return (
    <Flex width="100%" justifyContent="center" pb={1}>
      <DropsButton
        variant="ghost"
        size="sm"
        rightIcon={
          showAllStretches ? (
            <DropdownUpFill18Icon />
          ) : (
            <DropdownDownFill18Icon />
          )
        }
        fontWeight="normal"
        textAlign="center"
        justifyContent="center"
        alignItems="center"
        onClick={() => setShowAllStretches((prev) => !prev)}
      >
        {showAllStretches
          ? "Lukk visning"
          : `Vis alle strekninger (${stretchCount})`}
      </DropsButton>
    </Flex>
  );
};
